import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Web3 from "web3";
import { useDispatch, useSelector } from 'react-redux';
import web3ModalConfig from "../providerOption";
import { ethers } from 'ethers';
import secureAxios from '../secureAxios';
import IBackdrop from './backdrop.js';
import { LOGIN, LOGOUT, SET_ADMIN } from '../redux/actions/types';
import { useHistory } from "react-router-dom";
import queryString from 'query-string';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import InputLabel from '@mui/material/InputLabel';


import mainlogo from '../assets/logo.svg'

import usdtlogo from '../assets/usdt.png'
import slplogo from '../assets/slp.png'
import xeclogo from '../assets/xec.png'
import jasmylogo from '../assets/jasmy.png'
import { lightBlue } from '@mui/material/colors';
import vetlogo from '../assets/vet.png'
import openlogo from '../assets/open.png'
import winlogo from '../assets/win.png'
import _metaland from '../assets/Metaland.png';
import xunlogo from '../assets/xun.png';
import trxlogo from '../assets/trx.png';


const abi = [{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"assetProtectionRole","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"paused","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"betaDelegateWhitelister","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"proposedOwner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"EIP712_DOMAIN_HASH","outputs":[{"name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"supplyController","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"currentOwner","type":"address"},{"indexed":true,"name":"proposedOwner","type":"address"}],"name":"OwnershipTransferProposed","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"oldProposedOwner","type":"address"}],"name":"OwnershipTransferDisregarded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"oldOwner","type":"address"},{"indexed":true,"name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[],"name":"Pause","type":"event"},{"anonymous":false,"inputs":[],"name":"Unpause","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"addr","type":"address"}],"name":"AddressFrozen","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"addr","type":"address"}],"name":"AddressUnfrozen","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"addr","type":"address"}],"name":"FrozenAddressWiped","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"oldAssetProtectionRole","type":"address"},{"indexed":true,"name":"newAssetProtectionRole","type":"address"}],"name":"AssetProtectionRoleSet","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"SupplyIncreased","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"SupplyDecreased","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"oldSupplyController","type":"address"},{"indexed":true,"name":"newSupplyController","type":"address"}],"name":"SupplyControllerSet","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"},{"indexed":false,"name":"seq","type":"uint256"},{"indexed":false,"name":"fee","type":"uint256"}],"name":"BetaDelegatedTransfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"oldWhitelister","type":"address"},{"indexed":true,"name":"newWhitelister","type":"address"}],"name":"BetaDelegateWhitelisterSet","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"newDelegate","type":"address"}],"name":"BetaDelegateWhitelisted","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"oldDelegate","type":"address"}],"name":"BetaDelegateUnwhitelisted","type":"event"},{"constant":false,"inputs":[],"name":"initialize","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"initializeDomainSeparator","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_addr","type":"address"}],"name":"balanceOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_proposedOwner","type":"address"}],"name":"proposeOwner","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"disregardProposeOwner","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"claimOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"reclaimBUSD","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"pause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"unpause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_newAssetProtectionRole","type":"address"}],"name":"setAssetProtectionRole","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_addr","type":"address"}],"name":"freeze","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_addr","type":"address"}],"name":"unfreeze","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_addr","type":"address"}],"name":"wipeFrozenAddress","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_addr","type":"address"}],"name":"isFrozen","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_newSupplyController","type":"address"}],"name":"setSupplyController","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_value","type":"uint256"}],"name":"increaseSupply","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_value","type":"uint256"}],"name":"decreaseSupply","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"target","type":"address"}],"name":"nextSeqOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"sig","type":"bytes"},{"name":"to","type":"address"},{"name":"value","type":"uint256"},{"name":"fee","type":"uint256"},{"name":"seq","type":"uint256"},{"name":"deadline","type":"uint256"}],"name":"betaDelegatedTransfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"r","type":"bytes32[]"},{"name":"s","type":"bytes32[]"},{"name":"v","type":"uint8[]"},{"name":"to","type":"address[]"},{"name":"value","type":"uint256[]"},{"name":"fee","type":"uint256[]"},{"name":"seq","type":"uint256[]"},{"name":"deadline","type":"uint256[]"}],"name":"betaDelegatedTransferBatch","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_addr","type":"address"}],"name":"isWhitelistedBetaDelegate","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_newWhitelister","type":"address"}],"name":"setBetaDelegateWhitelister","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_addr","type":"address"}],"name":"whitelistBetaDelegate","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_addr","type":"address"}],"name":"unwhitelistBetaDelegate","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}]

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://mui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#fff', // your primary color
    }
  }
});

const styles = theme => ({
    multilineColor:{
        color:'red'
    }
});

export default function SignUp() {

  const application = useSelector(state => ({
    ...state.application
  }));

  

  const dispatch = useDispatch();
  let history = useHistory();

  const value=queryString.parse(window.location.search);
  const token=value.u;

  const customRanges = [
    { min: 20, max: 500, label: "Range 1" },
    { min: 501, max: 1500, label: "Range 2" },
    { min: 1501, max: 2500, label: "Range 3" },
    { min: 2501, max: 100000, label: "Range 3" },
    // Add more custom ranges as needed
  ];

  const getLogo = {
    usdt: usdtlogo,
    vet: vetlogo,
    open: openlogo,
    win: winlogo,
    metaland: _metaland,
    xun: xunlogo,
    trx: trxlogo
  }


  const [open, setOpen] = React.useState(false);
  const [showPassword, setShowpass] = React.useState(false);
  const [showPassword2, setShowpass2] = React.useState(false);
  const [modeOfMint, setModeOfMint] = React.useState(1);
  const [coin_code, setCoinCOde] = React.useState('metaland');

  const [password, setPassword] = React.useState("");
  const [password2, setPassword2] = React.useState("");


  const handleChange = (event) => {
    setModeOfMint(event.target.value);
  };

  const handleCoinChange = (event) => {
    setCoinCOde(event.target.value);
  };


  const isNumeric = (value) => {
    return /^-?\d+$/.test(value);
  }

  const checkRange = (amount) => {
    for (const range of customRanges) {
      if (amount >= range.min && amount <= range.max) {
        return true;
      }
    }
    return false;
  }


  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    console.log(data.get('Secret-id'))

    try{
      const amount = parseFloat(data.get('amount'))
    }
    catch (error){
      alert("Amount not valid")
      return false;
    }

    if (!checkRange(data.get('amount'))){
      alert("Please enter valid amount")
      return false;
    }

    if (data.get('amount') < 1){
      alert("Amount should be getter then 1")
      return false;
    }
    if (data.get('Secret-id') == "" || data.get('Secret-id').length < 4){
      alert("Secret Pin is not valid")
      return false;
    }

    try{
      let o = parseInt(data.get('Secret-id')) 
      if (o<1){
        alert("Secret Pin Should be numeric.")
        return false;
      }
    }
    catch(err){
      alert("Secret Pin Should be numeric.")
      return false;
    }

    let o = parseInt(data.get('Secret-id'))
    let o2 = parseInt(data.get('Secret-id2'))
    if (o != o2){
      alert("Secret Pin and Confirm Pin shoud be same")
      return false;
    }

    if (modeOfMint === 2 && data.get('amount') < 100){
      alert("Minimum stake amount should be 100")
      return false;
    }

    setOpen(true);
    connectWallet(data.get('Referral-id'), data.get('amount'), data.get('Secret-id'))
  };



  const connectWallet = async (sponser_id, amount, pin) => {
    const provider = await web3ModalConfig.connect();
    const library = new ethers.providers.Web3Provider(provider);
    const accounts = await library.listAccounts();
    const network = await library.getNetwork();
    if (network?.chainId != `${process.env.REACT_APP_NETWORK_ID}`){
      alert("Wrong network selected")
      setOpen(false)
      return;
    }
    if (accounts) {
      if (sponser_id != ""){
        check_sponserId(sponser_id, accounts[0], amount, pin)
      }
      else{
        alert("Please enter sponser id")
        setOpen(false);
      }
      
      //pay(accounts[0]);
    }
    

  };


  const check_sponserId = (sponser_id, address, amount, pin) => {
    
    secureAxios
        .post(`${process.env.REACT_APP_SERVICE_PYTHON_API_URL}/check_sponser`, {sponser: sponser_id.trim(), address: address}).then(response => {
          if (response.data?.success){
            pay(address, sponser_id.trim(), amount, pin);
          }
        }).catch(error => {
          setOpen(false);
          if (error.response.data?.non_field_errors){
            alert(error.response.data?.non_field_errors)
          }
          else{
            alert(error.response.data?.detail)
          }

        })
  }

  const register = (sponser_id, address, tx_hash, pin) => {
    
    secureAxios
        .post(`${process.env.REACT_APP_SERVICE_PYTHON_API_URL}/register`, {sponser: sponser_id, address: address, tx_hash: tx_hash, pin: pin, coin_code:coin_code, modeOfMint:modeOfMint}).then(response => {
          if (response.data?.success){
            localStorage.setItem('accessToken', response.data?.token?.access);
            dispatch({
              type: LOGIN,
              payload: {
                profile: {
                  account: address        
                },
                isAuthenticated: true
              }
            });
            history.push("/home");
          }
        }).catch(error => {
          setOpen(false);
          if (error.response.data?.non_field_errors){
            alert(error.response.data?.non_field_errors)
          }
          else{
            alert(error.response.data?.detail)
          }

        })
  }

const pay = async (address, sponser_id, _amount, pin) => {
  try{

  const to = "0x52CBF91E2D9fbF981cCa322cF97F95fa10249ffb"
  let amount = Web3.utils.toWei(_amount)
  // try {
    let web3;
      if (window.ethereum) {
          web3 = new Web3(window.ethereum);
      } else if (window.web3) {
          web3 = new Web3(window.web3.currentProvider);
      };

    let gasPrice = await web3.eth.getGasPrice();

    
    let _contract = new web3.eth.Contract(abi, '0x55d398326f99059fF775485246999027B3197955', {
      from: address,
    });

    let gasAmount = await _contract.methods.transfer(to, amount).estimateGas({ from: address });

    let contract = new web3.eth.Contract(abi, '0x55d398326f99059fF775485246999027B3197955', {
      from: address,
      gasPrice: gasPrice, // Set the gas price here
      gas: Web3.utils.toHex(gasAmount)
    });


    let sentInfo = await contract.methods.transfer(to, amount).send({from: address});

    if (sentInfo?.transactionHash) {
      register(sponser_id, address, sentInfo?.transactionHash, pin)
    }
  }

    catch(e){
      setOpen(false);
      alert("Balance not available")
    }
}



  React.useEffect(() => {
    const bodyElt = document.querySelector("body");
    bodyElt.style.background = "rgb(26,26,26)";

    return //This is important
  
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <IBackdrop isOpen={open} msg={"Signin progress"}/>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 5,
            display: 'flex',
            flexDirection: 'column',
            paddingTop: 5,
            paddingLeft:5,
            paddingRight:5,
            alignItems: 'center',
            boxShadow:  'rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 12%) 0px 12px 24px -4px;',
            transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;',
          
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'transparent' }}>
          <img style={{width: 25}} src={mainlogo} alt="fireSpot"/>
          </Avatar>
          <Typography component="h1" style={{color: "#fff"}} className='signup_span' variant="h5">
            Sign Up
          </Typography>
          <Box component="form" className='sign_up' onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          
            <TextField
              margin="normal"
              required
              fullWidth
              name="Referral-id"
              label="Referral Id"
              type="text"
              variant="outlined"               
              id="referral-id"
              defaultValue={token}
              autoComplete="referral-id"
            />
            <InputLabel style={{marginTop: '2px', fontSize: '10px'}}>If you don't have referral I'd, please use DEXFARM</InputLabel>
            <TextField
              margin="normal"
              required
              fullWidth
              name="Secret-id"
              label="Funding Password"
              type={showPassword ? "text" : "password"}
              variant="outlined"               
              id="secret-id"
              sx={{ input: { color: '#fff' } }} 
              autoComplete="off"
              value={password} // Ensure password state is defined and initialized as an empty string
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                endAdornment: !showPassword ? <Visibility onClick={() => setShowpass(true)}/>  : <VisibilityOff onClick={() => setShowpass(false)}/>
              }}
            />
             <TextField
              margin="normal"
              required
              fullWidth
              name="Secret-id2"
              label="Funding Confirm Password"
              type={showPassword2 ? "text" : "password"}
              variant="outlined"               
              id="secret-id2"
              sx={{ input: { color: '#fff' } }}
              value={password2} // Ensure password state is defined and initialized as an empty string
              onChange={(e) => setPassword2(e.target.value)}
              autoComplete="secret-id2"
              InputProps={{
                endAdornment: !showPassword2 ? <Visibility onClick={() => setShowpass2(true)}/>  : <VisibilityOff onClick={() => setShowpass2(false)}/>
              }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="amount"
              label="Stake amount"
              inputMode="numeric"
              type="number"
              InputProps={{
                type: 'number'
              }}
              variant="outlined"               
              id="stake-amount"
              sx={{ input: { color: '#fff' } }} 
              autoComplete="stake-amount"
            />
            {/* <Select
              value={modeOfMint}
              style={{
                marginTop: '10px',
              }}
              fullWidth
              onChange={handleChange}
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
            >             
              <MenuItem value={0}>Defi Auto Minting</MenuItem>
              <MenuItem value={1}>Defi Minting</MenuItem>
              <MenuItem value={2}>Defi Staking</MenuItem>
            </Select> */}
            

            <InputLabel style={{marginTop: '10px'}} id="select-label">Select Coin</InputLabel>
            <Select
                labelId="select-label"
                value={coin_code}
                style={{
                  marginTop: '10px',
                }}
                fullWidth
                className='select_coin'
                onChange={handleCoinChange}
                displayEmpty
                aria-label="Select an Option"

              > 

              <MenuItem disabled value={'usdt'}>
                <span className='tokenName'>
                  <img src={getLogo['usdt']} alt='USDT Icon' className='usdt' />
                  USDT (Sell out)</span>
                <span className='green_color'>(0%) APR</span>
              </MenuItem>
              <MenuItem disabled value={'vet'}>
                <span className='tokenName'>
                <img src={getLogo['vet']} alt='USDT Icon' className='usdt' />
                VET (Sell out) </span>
                <span className='green_color'>(0%) APR</span>
              </MenuItem>
              <MenuItem disabled value={'win'}>
                <span className='tokenName'>
                <img src={getLogo['win']} alt='USDT Icon' className='usdt' />WIN (Sell out)</span>
                <span className='green_color'> (0%) APR</span>
              </MenuItem>
              <MenuItem disabled value={'open'}>
                <span className='tokenName'>
                <img src={getLogo['open']} alt='USDT Icon' className='usdt' />OPEN (sell out)</span>
                <span className='green_color'>(0%) APR</span>
              </MenuItem> 
              <MenuItem value={'metaland'}>
                <span className='tokenName'>
                <img src={getLogo['metaland']} alt='USDT Icon' className='usdt' />METALAND</span>
                <span className='green_color'>(180%~600%) APR</span>
              </MenuItem>
              <MenuItem value={'xun'}>
                <span className='tokenName'>
                <img src={getLogo['xun']} alt='XUN Icon' className='xun' />XUN Protocol</span>
                <span className='green_color'>(150%~800%) APR</span>
              </MenuItem>
              <MenuItem value={'trx'}>
                <span className='tokenName'>
                <img src={getLogo['trx']} alt='TRX Icon' className='trx' />Tron</span>
                <span className='green_color'>(60%~120%) APR</span>
              </MenuItem>
                
              </Select>


            <Button
              style={{
                borderRadius: 35,
                backgroundColor: "transparent",
                fontSize: "14px",
                marginTop: '10px',
                color: 'rgb(24, 26, 32) !important',
                backgroundColor: "rgb(252, 213, 53)",
                marginBottom: '10px',
                width: '100%'
                
            }} variant="contained"
            type="submit"
            >
              Sign Up
            </Button>
            <Grid container style={{marginBottom: '70px'}}>
              <Grid item xs>
                <Link to="/login" style={{textDecoration: 'none', color: '#fff', fontSize: '12px'}} variant="body2">
                  {"Have an account? Sign In"}
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}